module.exports = __webpack_public_path__ + "static/media/gmail-overview.e3f19031.png";